import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const SalerBSEdit = props => (
  <Edit {...props} resource="salers">
    <Form />
  </Edit>
);

SalerBSEdit.propTypes = {};

export default SalerBSEdit;
